import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { AlertController } from 'ionic-angular';
import {AuthentificationService} from './authentification-service';
import {FirebaseListObservable} from 'angularfire2';
import { AngularFire} from 'angularfire2';
import 'rxjs/add/operator/map';


/*
  Generated class for the MenusService provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.

  Menus Service will manage the menus aswell as the favorites/propositions for a logged user
*/
@Injectable()
export class MenusService {
  private propositionList: FirebaseListObservable<any>;//List of propositions as we get it from Firebase
  private localFavs: Array<string>=new Array<string>();//List of favorites in form of an array of strings not a FirebaseListObservable object
  public menusFavoris: FirebaseListObservable<any[]>;//List of favorites in form of a FirebaseListObservable object
  public menus: any; //All the menus, retrieved from the JSON file of the Backend

  //Constructor for our provider
  constructor(public alertCtrl: AlertController,
  public http: Http, 
  public authentificationService: AuthentificationService,
  public af: AngularFire) {
    console.log('Hello MenusService Provider');
  }

  //returns the proposition of the day in form of a list of objects
  getPropositionList():Promise<Object[]>
  {
    return new Promise(resolve =>{
        this.af.database.list('/users/'+this.authentificationService.getUserId()+'/proposition').subscribe(res=>resolve(res));
    });
  }
  //returns the list of favorite dishes for the current user
  getFavsList(): Promise<Object[]>
  {
    this.menusFavoris=this.af.database.list('/users/'+this.authentificationService.getUserId()+'/favs');
    return new Promise(resolve=>{
      this.af.database.list('/users/'+this.authentificationService.getUserId()+'/favs').subscribe(res=>resolve(res));
    });
  }

  //returns true if the date of the menu corresponds to today's date
  isMenuFromToday(val: string)
  {  
    var today;
    var dd;
      today=new Date();
      dd = today.getDate();
      var res=val.split(" ");

      if(res[1]==dd)
      {
        return true;
      }
      else{
        return false;
      }
  }
  //LoadFavDishes takes the FireBaseListObservable and puts it into an array (localFavs)
  loadFavDishes()
  {
    this.localFavs=new Array<string>();
     this.getFavsList().then(data=>{
        data.forEach(element => {
            this.localFavs.push(element['label']);
        });
      });
  }
  //Returns true if string is in list of favorites
  isDishInFavs(dish: string):boolean
  {
    //console.log(this.localFavs);
      this.localFavs.forEach(element=>{
        if(element===dish)
        {
          //console.log(element +" is equal to "+dish);
          return true;
        }
      });
      return false;
  }
  //Links propositionList to the list stored in Firebase
  setProposition()
  {
        this.propositionList=this.af.database.list('/users/'+this.authentificationService.getUserId()+'/proposition');
  }
  //loads the menus from the backend
  loadMenus() {
    if (this.menus) {
      // already loaded data
      return Promise.resolve(this.menus);
    }
    
    // don't have the data yet
    return new Promise(resolve => {
      if(navigator.onLine){//There is an internet connection
        // We're using Angular HTTP provider to request the data,
        // then on the response, it'll map the JSON data to a parsed JS object.
        // Next, we process the data and resolve the promise with the new data.
        this.http.get('https://frimenu-backend.herokuapp.com/api/list-menus')
        .map(res => res.json())
        .subscribe(data => {
          // we've got back the raw data, now generate the core schedule data
          // and save the data for later reference
          resolve(data);
        });
      } else {//There is no internet connection
        //Display alert
        this.loadMenusNoNetworkAlert();
      }
    });
}

    //Un getter pour la e des préférences
    getFavoriteMenus()
    {
        return this.menusFavoris;
    }
    //Un setter pour rajouter un menu dans la liste de préférences
    addFavoriteMenu(ingredient: string)
    {
        //Add the dish to the favourites
        this.menusFavoris.push({
           "label": ingredient
        });
        this.loadFavDishes();
        //Check connection state
        if(navigator.onLine){//There is an internet connection
          this.favAddedAlert(ingredient);
        } else {//There is no internet connection
          this.favsNoNetworkAlert();
        }
    }
    //Méthode qui permet de supprimer un plat dans la liste de préférences
    removeFromFavorites(ingredient: string)
    {
        //Add the dish to the favourites
        this.menusFavoris.remove(ingredient);
        this.loadFavDishes();
        //Check connection state
        if(!navigator.onLine){//There is no internet connection
          this.favsNoNetworkAlert();
        }
    }

  /*
  * Show an alert indicating that there is no internet connection
  */
  loadMenusNoNetworkAlert() {
    let networkAlert = this.alertCtrl.create({//Prepare alert
      title: 'Pas de connexion internet',
      message: 'Sans connexion à internet, vous ne pouvez pas récupérer les derniers menus.',
      buttons: ['OK']
    });
    //Display alert
    networkAlert.present();
  }
  /*
  * Show an alert indicating that there is no internet connection
  */
  favsNoNetworkAlert() {
    let networkAlert = this.alertCtrl.create({//Prepare alert
      title: 'Pas de connexion internet',
      message: 'Si vous rechargez la page avant que la connexion à internet soit revenue, vous perdrez toutes vos modifications sur vos plats favoris',
      buttons: ['OK']
    });
    //Display alert
    networkAlert.present();
  }
  /*
  * Show an alert indicating that the dish was added to the favourites
  */
  favAddedAlert(ingredient: string){
    let alert = this.alertCtrl.create({
			  title: 'Ajouté aux plats préférés',
			  message: 'Vous avez rajouté "'+ingredient+'" à vos plats préférés!',
			  buttons: ['OK']
			});
    //Display alert
			alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/providers/menus-service.ts